import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { placeholderImage } from '@grandvisionhq/utils';

const CardImage = (_param)=> {
    var { alt , src , backgroundColor , className , style  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "alt",
        "src",
        "backgroundColor",
        "className",
        "style"
    ]);
    return React.createElement("img", swcHelpers.extends({}, rest, {
        className: classnames('card-image', className, {
            'card-image--placeholder': !src
        }),
        // Even though it's required, the src might be an empty string.
        src: src || placeholderImage.url,
        alt: alt || '',
        style: swcHelpers.objectSpread({
            backgroundColor
        }, style)
    }));
};
var CardImage$1 = CardImage;

export { CardImage$1 as default };
//# sourceMappingURL=CardImage.js.map
